module.exports = __webpack_public_path__ + "static/media/checkmark.43a9d1df.svg";